import React from 'react';
import PropTypes from 'prop-types';
import { useBrand } from '@edreamsodigeo/frontend-core';
import { Box, Image } from '@edreamsodigeo/prisma-design-system';

const brandDetails = {
  ED: {
    path: 'ED/prime_logo/ED-logo-prime-long',
    name: 'edreams',
    height: '16px',
  },
  GO: {
    path: 'GV/prime_logo/GO-logo-prime-long',
    name: 'govoyages',
    height: '16px',
  },
  OP: {
    path: 'OP/prime_logo/OP-logo-prime-long',
    name: 'opodo',
    height: '16px',
  },
};

const brandNegativeColors = {
  ED: {
    path: '/images/prime/Logos/new/logo_edp_long_neg_transp.png',
  },
  GO: {
    path: '/images/prime/Logos/GO_Logo_negative.png',
  },
  OP: {
    path: '/images/prime/Logos/OP-Prime-Negative-25px@2x.png',
  },
};

export const PrimeLogoLong = ({ negativeColor, extraProps }) => {
  const brand = useBrand();
  const path = '/images/onefront/bluestone';
  const imageName = brandDetails[brand].path;
  let logoImageUrl = `${path}/${imageName}.svg`;

  if (negativeColor) {
    logoImageUrl = brandNegativeColors[brand].path;
  }

  return (
    <Box pt="2x_small">
      <Image
        src={logoImageUrl}
        alt={`${brandDetails[brand].name} logo prime image`}
        height={`${brandDetails[brand].height}`}
        size="auto"
        {...extraProps}
      ></Image>
    </Box>
  );
};

PrimeLogoLong.propTypes = {
  negativeColor: PropTypes.bool,
  extraProps: PropTypes.object,
};
